module.exports = __webpack_public_path__ + "img/1296612824.8411837a.jpg";